import { gql } from "@apollo/client";

export const AdressFragment = gql`
  fragment AdressFragment on Address {
    country
    city
    region
    address
    additional_address
    location {
      latitude
      longitude
    }
    place_id
  }
`;

export const ParcelListFragment = gql`
  fragment ParcelListFragment on Parcel {
    _id
    parcel_UID
    parcel_size
    parcel_value
    parcel_description
    parcel_remittance_due_date
    parcel_remittance_created_at
    parcel_cash_status
    parcel_amount_to_collect
    parcel_status
    isRelayActionOpened
    parcel_created_at
    parcel_client_reference
    parcel_cash_collection_date
    parcel_created_by {
      user_id
      source
    }
    parcel_last_edited_at
    parcel_delivery_slot_start
    parcel_delivery_slot_end
    parcel_return_raison
    parcel_additional_info
    amountCollected
    parcel_client {
      _id
      client_company_name
      client_phone_number
      client_address {
        ...AdressFragment
      }
    }
    parcel_runsheet {
      runsheet_driver {
        driver_UID
        driver_firstname
        driver_lastname
        driver_phone_number
      }
      runsheet_vehicle_type
      runsheet_conveyor {
        conveyor_UID
        conveyor_firstname
        conveyor_lastname
        conveyor_phone_number
      }
    }
    parcel_order {
      _id
      order_UID
      order_status
      order_receiver {
        _id
        receiver_firstname
        receiver_lastname
        receiver_entreprise
        receiver_address {
          ...AdressFragment
        }
      }
      order_job {
        job_type
      }
      deliveryAddress {
        address
      }
    }
    parcel_reason {
      _id
      reason_name
    }
    parcel_delivery_date
    parcel_attempts
    parcel_attempts_real
    countries {
      code
      name
    }
    tag
    isOutOfStock
    comment
    relay {
      _id
      name
      code
      types
      location {
        country
        city
        region
        place_id
        address
        additional_address
        location {
          latitude
          longitude
        }
      }
    }
    pickupAddress {
      address
    }
    pickupMoreInfo {
      firstName
      lastName
      phoneNumber
    }
  }
  ${AdressFragment}
`;

export const ReceiverInfoFragment = gql`
  fragment ReceiverInfo on Receiver {
    _id
    receiver_lastname
    receiver_firstname
    receiver_email
    receiver_phone_number
    receiver_specification_address
    receiver_entreprise
    receiver_created_at
    receiver_last_edited_at
    receiver_address {
      ...AdressFragment
    }
  }
  ${AdressFragment}
`;